import * as types from './types';

const result = (type, payload) => {
  return {
    type: type,
    payload: payload,
  };
};

export const setAlreadyRedirect = (payload) => result(types.SET_ALREADY_REDIRECT, payload);
export const getUser = (payload) => result(types.GET_USER, payload);
export const getUserSuccess = (payload) =>
  result(types.GET_USER_SUCCESS, payload);
export const getUserError = (payload) => result(types.GET_USER_ERROR, payload);

export const login = (payload) => result(types.LOGIN, payload);
export const loginSuccess = (payload) => result(types.LOGIN_SUCCESS, payload);
export const loginError = (payload) => result(types.LOGIN_ERROR, payload);

export const update = (payload) => result(types.UPDATE, payload);
export const updateSuccess = (payload) => result(types.UPDATE_SUCCESS, payload);
export const updateError = (payload) => result(types.UPDATE_ERROR, payload);

export const registrationRequest = (payload) =>
  result(types.REGISTRATION_REQUEST, payload);
export const registrationRequestSuccess = (payload) =>
  result(types.REGISTRATION_REQUEST_SUCCESS, payload);
export const registrationRequestError = (payload) =>
  result(types.REGISTRATION_REQUEST_ERROR, payload);

export const signOut = (payload) => result(types.SIGN_OUT, payload);
